module.exports = __webpack_public_path__ + "img/14.b2452496.png";